import { Component, OnInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router, ActivatedRoute } from "@angular/router";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { ForgetPasswordService } from "./forgetPassword.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { RouterHelperService } from "../../services/routerHelper.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { FormGroup } from "@angular/forms";
import { FormHelperService } from "../../services/formHelper.service";

@Component({
  selector: "forgetPassword",
  templateUrl: "./forgetPassword.component.html",
  styleUrls: ["./forgetPassword.component.scss"],
  providers: [ForgetPasswordService, FormHelperService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {

  public userName: string;
  public forgetPasswordFailed: boolean = false;

  private langSubscriber: Subscription;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _location: Location
    , private _router: Router
    , private _activatedRoute: ActivatedRoute
    , private _snackBarService: SnackBarService
    , private _routerHelperService: RouterHelperService
    , private internationalisationService: InternationalisationService
    , private _forgetPasswordService: ForgetPasswordService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _formHelperService: FormHelperService) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ForgetPasswordComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.setRouteData();
    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    me.PushChanges();
  }

  /**
  * Set the title of the page by title Data in route data
  * This data has been set in RouterHelperService by each navigation End Event
  */
  private setRouteData(): void {
    const me = this;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["userName"]) {
      me.userName = routeTargetData["userName"];
    }
  }

  public resetPassword(form: FormGroup): void {
    const me = this;
    if (form.valid) {
      me._overlaySpinnerService.ShowLayoutSpinner();
      me._forgetPasswordService.SendForgetPasswordRequest(me.userName)
        .then(() => {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
          me._routerHelperService.setRouteTargetDataByKey("forgetPassword", true);
          me._routerHelperService.setRouteTargetDataByKey("tabIndex", 1);
          me._router.navigateByUrl("/registration");
          me.forgetPasswordFailed = false;
        })
        .catch(() => {
          me.forgetPasswordFailed = true;
          me._snackBarService.ShowErrorMessageFailed(31);
          me._overlaySpinnerService.HideLayoutSpinner();
          me.PushChanges();
        });
    }
  }

  /**show all validation message by clicking on desabled button */
  public showValidationMessage(formGroup: FormGroup): void {
    const me = this;
    me._formHelperService.showValidationMsg(formGroup);
    me.PushChanges();
  }

  /**to click the button by pressing the EnterKey */
  public handleEnterKeyup(ismobile: boolean): void {
    if (!ismobile && document.getElementById("submitForm"))
      document.getElementById("submitForm").click();
  }

  public navigateBack(): void {
    const me = this;
    me._routerHelperService.setRouteTargetDataByKey("tabIndex", 1);
    me._location.back();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }

}
